module.exports = __webpack_public_path__ + "img/744.b73ec297.jpg";